import { useState } from 'react'

import type { useCreateToolbarItem } from '#/features/shipment-toolbar'

interface NoteSliceDeps {
  shipmentId: string | undefined
  createNote: ReturnType<typeof useCreateToolbarItem>['createNote']
  isPending: boolean
  closeTab: () => void
}

export function useNoteSlice({
  shipmentId,
  createNote,
  isPending,
  closeTab,
}: NoteSliceDeps) {
  const [html, setHtml] = useState('')

  const reset = () => {
    setHtml('')
    closeTab()
  }

  const onSave = async (next: string) => {
    if (!shipmentId || !next.trim() || isPending) return
    try {
      await createNote({ text: next })
    } catch {
      return // onError already surfaced the failure; keep the draft
    }
    reset()
  }

  return {
    value: html,
    onChange: setHtml,
    onCancel: reset,
    onSave,
    isSaving: isPending,
    canSave: Boolean(shipmentId),
  }
}
